function hash(input: string): string {
  return farmhash(input).toString(16);
}

function farmhash(input: string): number {
  const seed = 0x9e3779b9;
  let hash = seed;

  for (let i = 0; i < input.length; i++) {
    const charCode = input.charCodeAt(i);
    hash ^= charCode;
    hash = Math.imul(hash, 0x5bd1e995);
    hash ^= hash >>> 15;
  }

  hash = Math.imul(hash, 0x5bd1e995);
  hash ^= hash >>> 13;
  hash = Math.imul(hash, 0x5bd1e995);
  hash ^= hash >>> 15;

  return hash >>> 0;
}

function prepareObject(obj: any): any {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(prepareObject);
  }
  const sortedObj: any = {};
  for (const key of Object.keys(obj).sort()) {
    if (obj[key] === null || obj[key] === undefined) {
      continue;
    }
    sortedObj[key] = prepareObject(obj[key]);
  }
  return sortedObj;
}

export function generateHash(input: object | string, debug = false): string {
  if (typeof input === "object") {
    const sanitized = JSON.stringify(prepareObject(input));
    if (debug) {
      console.log("Hashing sanitized string:");
      console.log(sanitized);
    }
    return hash(sanitized);
  } else {
    try {
      const obj = JSON.parse(input);
      const sanitized = JSON.stringify(prepareObject(obj));
      if (debug) {
        console.log("Hashing sanitized string:");
        console.log(sanitized);
      }
      return hash(sanitized);
    } catch {
      return hash(input);
    }
  }
}
